module.exports = __webpack_public_path__ + "static/media/eCards_empty.50469088.svg";